// extracted by mini-css-extract-plugin
module.exports = {"locationList":"index-module--locationList--3-9MT","country":"index-module--country--1WwBy"};